module.exports = __webpack_public_path__ + "static/media/004_Clima.f53a6dcf.mp4";